import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { AuthService } from "app/core/auth/auth.service";
import { catchError, map, of, take, switchMap } from "rxjs";

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const isLocalhost =
    typeof location !== 'undefined' && location.host.includes('localhost');

  if (!authService.getAccessToken()) {
    const rt = localStorage.getItem('refreshToken');
    if (rt && rt !== 'undefined') {
      // Refrescar el token y permitir que el componente cargue el usuario
      return authService.getRefreshToken().pipe(
        map((result) => {
          if (!result) {
            // No se pudo refrescar, redirigir al IDP
            authService.redirectIDP();
            return false;
          }
          return true;
        }),
        catchError(() => {
          // Error al refrescar, redirigir al IDP
          authService.redirectIDP();
          return of(false);
        })
      );
    } else {
      if (isLocalhost) {
        authService.setAccessToken('local-dev-token');
        localStorage.setItem('refreshToken', 'local-dev-refresh');
        return of(true);
      }
      authService.redirectIDP();
      return of(false);
    }
  }

  return authService.currentUser$.pipe(
    take(1),
    map(() => true),
    catchError(() => of(false))
  );
};
